import { Img, Lightning, Utils } from '@lightningjs/sdk'

export default class StationCover extends Lightning.Component {
  static _template() {
    return {
      w: 85,
      h: 85,
      BrandBorderN: {
        w: 85,
        h: 85,
        rect: true,
        alpha: 1,
        src: Utils.asset('images/StationBorder.png'),
      },
      BrandBorderF: {
        w: 85,
        h: 85,
        rect: true,
        alpha: 0,
        src: Utils.asset('images/StationBorderF.png'),
      },
      BrandImg: {
        w: 100,
        h: 100,
        x: 7,
        y: 7,
        src: this.bindProp('stationLogo'),
      },
    }
  }

  set item(itm) {
    this._item = itm
    const stationLogo = itm.logos.normal

    this.tag('BrandImg').texture = Img(stationLogo, {
      w: 85,
      h: 85,
      type: 'cover',
    })
  }

  get item() {
    return this._item
  }
  _init() {
    this.transition('x').on('finish', () => {
      this.alpha = 1
    })
  }

  set __shifted(bool) {
    this._isShifted = bool

    if (this._isShifted === true) {
      this.alpha = 0
    }
  }

  set size({ width = 85, height = 85, xPosition = 0, yPosition = 0, smoothDuration = 0.7 }) {
    const ease = 'cubic-bezier(.13,.66,.19,.94)'
    let preW = this.tag('BrandImg').w
    this.patch({
      smooth: {
        w: [width, { duration: smoothDuration, timingFunction: ease }],
        h: [height, { duration: smoothDuration, timingFunction: ease }],
        x: [xPosition, { duration: smoothDuration, timingFunction: ease }],
        y: [yPosition, { duration: smoothDuration, timingFunction: ease }],
      },
      BrandBorderN: {
        smooth: {
          w: [width, { duration: smoothDuration, timingFunction: ease }],
          h: [height, { duration: smoothDuration, timingFunction: ease }],
        },
      },
      BrandBorderF: {
        smooth: {
          w: [width, { duration: smoothDuration, timingFunction: ease }],
          h: [height, { duration: smoothDuration, timingFunction: ease }],
        },
      },
      BrandImg: {
        smooth: {
          w: [width - 14, { duration: smoothDuration, timingFunction: ease }],
          h: [height - 14, { duration: smoothDuration, timingFunction: ease }],
        },
      },
    })
    if (preW !== width - 14)
      this.tag('BrandImg').texture = Img(this._item.logos.normal, {
        w: width,
        h: height,
        type: 'cover',
      })
  }

  set selected(bool) {
    this._selected = bool
  }

  get dataIndex() {
    return this._item.dataIndex
  }

  set dataIndex(idx) {
    this._item.dataIndex = idx
  }

  _focus() {
    this.patch({
      BrandBorderF: {
        smooth: {
          alpha: [
            1,
            {
              duration: 0.6,
              delay: 0.1,
              timingFunction: 'cubic-bezier(.13,.66,.19,.94)',
            },
          ],
        },
      },
    })
  }

  _unfocus() {
    this.patch({
      BrandBorderF: {
        smooth: {
          alpha: [
            0,
            {
              duration: 0.3,
              delay: 0.6,
              timingFunction: 'cubic-bezier(.13,.66,.19,.94)',
            },
          ],
        },
      },
    })
  }
}
